<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between align--center mb-3">
          <h1 class="ma-0">Типы доставки</h1>
          <va-button color="info" @click="openCreateModal">
            Добавить тип
          </va-button>
        </div>
        <va-data-table
          :fields="fields"
          :data="list"
          class="va-table va-table--hoverable"
        >
          <template slot="title" slot-scope="props">
            {{ props.rowData.title }}
          </template>
          <template slot="code" slot-scope="props">
            {{ props.rowData.code }}
          </template>
          <template slot="price" slot-scope="props">
            {{ props.rowData.price }}
          </template>
          <template slot="free_from_sum" slot-scope="props">
            {{
              props.rowData.free_from_sum != null
                ? props.rowData.free_from_sum
                : "—"
            }}
          </template>
          <template slot="time" slot-scope="props">
            {{ formatTime(props.rowData.time_from) }} –
            {{ formatTime(props.rowData.time_to) }}
          </template>
          <template slot="is_active" slot-scope="props">
            <va-badge
              :text="props.rowData.is_active ? 'Да' : 'Нет'"
              :color="props.rowData.is_active ? 'success' : 'gray'"
            />
          </template>
          <template slot="actions" slot-scope="props">
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-pencil"
              @click="edit(props.rowData)"
            />
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-trash"
              @click="remove(props.rowData.id)"
            />
          </template>
        </va-data-table>
      </va-card>
    </va-inner-loading>

    <va-modal v-model="showModal" hide-default-actions size="medium">
      <template #header>
        <span>{{
          editId ? "Редактировать тип доставки" : "Новый тип доставки"
        }}</span>
      </template>
      <DeliveryTypeForm
        :initial="editItem"
        @submit="onSubmit"
        @cancel="closeModal"
      />
    </va-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import DeliveryTypeForm from "../../components/delivery-management/DeliveryTypeForm.vue";

export default {
  name: "DeliveryTypes",
  components: { DeliveryTypeForm },
  data() {
    return {
      showModal: false,
      editId: null,
      editItem: null,
    };
  },
  computed: {
    ...mapState("deliveryTypes", ["list"]),
    ...mapGetters({ loader: "isLoading" }),
    fields() {
      return [
        { name: "__slot:title", title: "Название" },
        { name: "__slot:code", title: "Код" },
        { name: "__slot:price", title: "Базовая цена" },
        { name: "__slot:free_from_sum", title: "Бесплатно от суммы" },
        { name: "__slot:time", title: "Время действия" },
        { name: "__slot:is_active", title: "Активна" },
        { name: "__slot:actions", title: "", width: "100px" },
      ];
    },
  },
  async created() {
    await this.fetchList();
  },
  methods: {
    ...mapActions("deliveryTypes", ["fetchList", "create", "update", "delete"]),
    formatTime(t) {
      if (!t) return "—";
      return String(t).substring(0, 5);
    },
    openCreateModal() {
      this.editId = null;
      this.editItem = null;
      this.showModal = true;
    },
    edit(row) {
      this.editId = row.id;
      this.editItem = { ...row };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editId = null;
      this.editItem = null;
    },
    async onSubmit(form) {
      try {
        if (this.editId) {
          await this.update({ id: this.editId, ...form });
          this.$notify?.({ type: "success", title: "Сохранено" });
        } else {
          await this.create(form);
          this.$notify?.({ type: "success", title: "Создано" });
        }
        this.closeModal();
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
    async remove(id) {
      if (!confirm("Удалить тип доставки?")) return;
      try {
        await this.delete(id);
        this.$notify?.({ type: "success", title: "Удалено" });
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
  },
};
</script>
